module.exports = __webpack_public_path__ + "static/media/intro.737fa871.mp3";